import { render } from "./loading-page.vue?vue&type=template&id=18a5a8ac&scoped=true"
import script from "./loading-page.vue?vue&type=script&lang=js"
export * from "./loading-page.vue?vue&type=script&lang=js"

import "./loading-page.vue?vue&type=style&index=0&id=18a5a8ac&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18a5a8ac"]])

export default __exports__